import { type FC } from "react";
import "./fieldCard.less";
import { type FieldCardTypes } from "../types";
import { Radio } from "syngenta-digital-cropwise-react-ui-kit";
import { FieldThumbnail } from "./FieldThumbnail";
import { useNewTrialState } from "../../../pages/new-trail/hooks/NewTrialStateProvider";
import { allowFieldInputChange } from "../../../pages/new-trail/utils";
import { useTranslation } from "react-i18next";
import { formatTranslation } from "../../utils/translationUtils";

export const FieldCard: FC<FieldCardTypes> = ({
  fieldName,
  id,
  image,
  onChange,
  geojson,
  fieldArea,
}) => {
  const { t } = useTranslation();
  const { trialInfo, newTrialState, current } = useNewTrialState();
  const isDisabled = !allowFieldInputChange(trialInfo, newTrialState);

  const isSelected = current === 0 && trialInfo?.field_ids[0] === id;

  return (
    <div
      className={`radio-card-main ${isDisabled ? "is-disabled" : ""}`.trim()}
      style={
        isSelected
          ? {
              border: "2px solid #31B4F2",
              backgroundColor: "rgba(49, 180, 242, 0.30)",
              boxShadow: "0px 2px 8px 0px rgba(0, 0, 0, 0.15)",
            }
          : {}
      }
    >
      <Radio.Group onChange={onChange} value={trialInfo?.field_ids[0]}>
        <Radio
          disabled={isDisabled}
          value={id}
          data-testid="radio-btn"
          className="radio-btn"
        />
      </Radio.Group>
      <div className="img-section">
        {image ? (
          <img src={image} alt="field-img" />
        ) : (
          geojson && <FieldThumbnail geojson={geojson} style={{}} />
        )}
      </div>
      <div className="details">
        <h3 data-testid={fieldName}>{fieldName}</h3>
        <p data-testid="field-area">
          {fieldArea?.toFixed(2)} {formatTranslation(t("shared.haUnit"))}
        </p>
      </div>
      <Radio.Group onChange={onChange} value={trialInfo?.field_ids[0]}>
        <Radio
          disabled={isDisabled}
          value={id}
          data-testid="radio-div"
          className="radio-div"
        />
      </Radio.Group>
    </div>
  );
};
